<template>
  <div class="w-full">
    <button
      @click="onToggle"
      :class="[
        'p-2 w-full flex items-center hover:bg-gray-700 rounded-lg cursor-pointer',
        expanded ? 'justify-start' : 'justify-center'
      ]"
    >
      <component :is="toggleIcon" :stroke="NavigationPaneActiveFillColor" />
      <span v-if="expanded" class="ml-2 whitespace-nowrap">Minimize</span>
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { type Position } from '../types/NavigationPane'
import { ChevronLeftIcon, ChevronRightIcon, ChevronDownIcon, ChevronUpIcon } from '../../icons'
import { NavigationPaneActiveFillColor } from '../constants/navigationPaneDefaults'

// Define toggle icon directions
const toggleIconChoice = {
  top: {
    expanded: ChevronUpIcon,
    collapsed: ChevronDownIcon
  },
  left: {
    expanded: ChevronLeftIcon,
    collapsed: ChevronRightIcon
  },
  right: {
    expanded: ChevronRightIcon,
    collapsed: ChevronLeftIcon
  },
  bottom: {
    expanded: ChevronDownIcon,
    collapsed: ChevronUpIcon
  }
}

export default defineComponent({
  name: 'NavigationPaneToggle',
  components: {
    ChevronLeftIcon,
    ChevronRightIcon,
    ChevronDownIcon,
    ChevronUpIcon
  },
  props: {
    position: {
      type: String as () => Position,
      required: true
    },
    expanded: {
      type: Boolean,
      required: true
    }
  },
  emits: ['toggle'],
  setup(props, { emit }) {
    const toggleIcon = computed(() => {
      return props.expanded
        ? toggleIconChoice[props.position].expanded
        : toggleIconChoice[props.position].collapsed
    })

    const onToggle = () => {
      emit('toggle')
    }

    return {
      toggleIcon,
      onToggle,
      NavigationPaneActiveFillColor
    }
  }
})
</script>
